import { connect } from 'react-redux';

import Currency from '../../components/currencycalculator/Currency';
import withTickerSubscribe from '../../hoc/withTickerSubscribe';

import { requestTickerData } from '../../actions/ticker';
import normalizeSymbol from '../../service/normalizesymbol';

function mapStateToProps({ tickers }, { symbol }) {
    let ticker;
    if (symbol === 'X:SSEKSEK.IDCFX') {
        ticker = {
            ITEM: 'X:SSEKSEK',
            SECTOR: 'IDCFX',
            LONG_NAME: 'Svenska kronor',
            LAST: 1,
            LASTNZ: 1,
            LASTNZ_DIV: 1,
        };
    } else if (symbol.match(/CRYPTO$/i)) {
        const tmp = tickers[normalizeSymbol(symbol)] || {};
        ticker = {
            ITEM: tmp.ITEM,
            SECTOR: tmp.SECTOR,
            LONG_NAME: tmp.LONG_NAME,
            SHORT_NAME: tmp.SHORT_NAME,
            LAST: tmp.LAST_SEK,
            LASTNZ: tmp.LAST_SEK,
            LASTNZ_DIV: tmp.LAST_SEK,
        };
    } else {
        ticker = tickers[normalizeSymbol(symbol)] || {};
    }

    return {
        ...ticker,
    };
}

const mapDispatchToProps = {
    requestTickerData,
};

export default connect(mapStateToProps, mapDispatchToProps)(
    withTickerSubscribe(Currency),
);



/** WEBPACK FOOTER **
 ** /src/shared/containers/currencycalculator/Currency.js
 **/